module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-06.d63a42c3.jpg";